import store from './../configuration/store';
import configuration from './../configuration/server';
import AWS from 'aws-sdk';
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { IDENTITY_LOGIN_OK } from '../reducers/types';
import { logout, getProfile } from './../reducers/identity';
import { DataStorage } from './storage';

const userPool = new CognitoUserPool({
    UserPoolId: configuration[configuration.STAGE].cognito.USER_POOL_ID,
    ClientId: configuration[configuration.STAGE].cognito.APP_CLIENT_ID
});

export function initializeIdentity() {
    if (AWS.config.credentials && Date.now() < AWS.config.credentials.expireTime - 60000) {
        return;
    }

    const currentUser = userPool.getCurrentUser();
    if (currentUser === null) {
        return;
    }

    currentUser.getSession(function(error, session) {
        if (error || !session) {
            logout(store.dispatch);
        }

        store.dispatch({ type: IDENTITY_LOGIN_OK, data: session });
        getProfile();
    });
}

export function parseSelectedRole(roles) {
    let raw = DataStorage.getRole();
    if (!raw) {
        return undefined;
    }

    let role = roles.filter(r => JSON.stringify(r) === raw);
    if (!role || roles.length === 0) {
        return undefined;
    }

    return role[0];
}



// WEBPACK FOOTER //
// ./src/utilities/user.jsx